import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import App from "./App"
import store from "./store"
import "./i18n"

// ─── Global 401 interceptor ──────────────────────────────────
// Wraps fetch so ANY API call returning 401 auto-redirects to /login
const _origFetch = window.fetch
window.fetch = async (...args) => {
  const response = await _origFetch(...args)
  if (response.status === 401) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || ""
    if (url.includes("devsoundfusion.com")) {
      localStorage.removeItem("authUser")
      window.location.href = "/login"
    }
  }
  return response
}

const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
